import { Component } from '@angular/core';

@Component({
  selector: 'kh-logo',
  styleUrls: ['./logo.component.less'],
  templateUrl: './logo.component.html',
  standalone: false
})
export class LogoComponent {}
